'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = findPhoneNumbersInText;
exports.getArguments = getArguments;

var _findNumbers = require('./findNumbers');

var _findNumbers2 = _interopRequireDefault(_findNumbers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findPhoneNumbersInText(text, defaultCountry, options, metadata) {
	var args = getArguments(defaultCountry, options, metadata);
	return (0, _findNumbers2.default)(text, args.options, args.metadata);
}

function getArguments(defaultCountry, options, metadata) {
	if (metadata) {
		if (defaultCountry) {
			options = _extends({}, options, {
				defaultCountry: defaultCountry
			});
		}
	} else {
		if (options) {
			metadata = options;
			if (defaultCountry) {
				if (is_object(defaultCountry)) {
					options = defaultCountry;
				} else {
					options = { defaultCountry: defaultCountry };
				}
			} else {
				options = undefined;
			}
		} else {
			metadata = defaultCountry;
			options = undefined;
		}
	}
	return {
		options: _extends({}, options, {
			v2: true
		}),
		metadata: metadata
	};
}

// Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */
var is_object = function is_object(_) {
	return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object';
};
//# sourceMappingURL=findPhoneNumbersInText.js.map